import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const FORM_SERVICE_GROUP_CONTEXT_SYMBOL = Symbol();
const useFormServiceGroup = ()=>useImmutableContext(FORM_SERVICE_GROUP_CONTEXT_SYMBOL);
const useFormServiceGroupProvider = (...args)=>useImmutableContextProvider(FORM_SERVICE_GROUP_CONTEXT_SYMBOL, ...args);
export { useFormServiceGroup, useFormServiceGroupProvider };
